import React, { useState, useRef, useEffect } from 'react'

const CertificateSelect = ({ certificates: certificatesJson, selectedId, hiddenFieldId, positionWrapperId }) => {
  const certificates = typeof certificatesJson === 'string' ? JSON.parse(certificatesJson) : (certificatesJson || [])
  const initialId = selectedId ? String(selectedId) : ''
  const [selected, setSelected] = useState(initialId)
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  const selectedCert = certificates.find(c => String(c.id) === selected)

  useEffect(() => {
    const hiddenField = document.getElementById(hiddenFieldId)
    if (hiddenField) {
      hiddenField.value = selected
    }
    if (positionWrapperId) {
      const positionEl = document.getElementById(positionWrapperId)
      if (positionEl) {
        positionEl.style.display = selected ? '' : 'none'
      }
    }
  }, [selected, hiddenFieldId, positionWrapperId])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelect = (id) => {
    setSelected(id)
    setIsOpen(false)
  }

  return (
    <div className='relative' ref={dropdownRef}>
      <button
        type='button'
        onClick={() => setIsOpen(!isOpen)}
        className='mt-1 block w-full h-10 px-3 rounded-md border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm text-left flex items-center justify-between'
      >
        <span className='flex items-center gap-2'>
          {selectedCert ? (
            <>
              {selectedCert.image && (
                <img src={selectedCert.image} alt={selectedCert.name} className='h-6 w-6 object-contain' />
              )}
              <span>{selectedCert.name}</span>
            </>
          ) : (
            <span className='text-gray-400'>None</span>
          )}
        </span>
        <svg className='w-4 h-4 text-gray-400' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
        </svg>
      </button>

      {isOpen && (
        <div className='absolute z-20 mt-1 w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-lg max-h-60 overflow-auto'>
          <button
            type='button'
            onClick={() => handleSelect('')}
            className={`w-full px-3 py-2 text-left text-sm flex items-center gap-2 hover:bg-gray-100 dark:hover:bg-gray-600 ${
              !selected ? 'bg-blue-50 dark:bg-blue-900/30' : ''
            }`}
          >
            <span className='text-gray-400 dark:text-gray-300'>None</span>
          </button>
          {certificates.map(cert => (
            <button
              type='button'
              key={cert.id}
              onClick={() => handleSelect(String(cert.id))}
              className={`w-full px-3 py-2 text-left text-sm flex items-center gap-2 hover:bg-gray-100 dark:hover:bg-gray-600 ${
                String(cert.id) === selected ? 'bg-blue-50 dark:bg-blue-900/30' : ''
              }`}
            >
              {cert.image && (
                <img src={cert.image} alt={cert.name} className='h-8 w-8 object-contain' />
              )}
              <span className='text-gray-900 dark:text-white'>{cert.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default CertificateSelect
